import React from 'react';
import PropTypes from 'prop-types';
import { HourglassMedium, XCircle } from '@phosphor-icons/react';
import Typography from '../../components/Typography';
import './portalAccessStatus.scss';

export const PORTAL_ACCESS_BLOCKED_STATUSES = ['pending_approval', 'rejected'];

const joinNames = (names) => {
  if (names.length <= 1) return names[0] || '';
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
};

// Shown in place of the portal while the referring practice has not approved
// this partner (or declined them). Without it the partner sees an empty tracker
// with an error banner and no idea what happens next.
const PortalAccessStatus = ({ status, approvingOrganizations }) => {
  const pending = status === 'pending_approval';
  const approver = joinNames(approvingOrganizations) || 'The practice that invited you';

  return (
    <div className="portal-access-status" data-testid="portal-access-status">
      <div className={`portal-access-status__icon portal-access-status__icon--${pending ? 'pending' : 'rejected'}`}>
        {pending ? <HourglassMedium size={28} weight="duotone" /> : <XCircle size={28} weight="duotone" />}
      </div>

      <Typography variant="h1" size="large" bold className="portal-access-status__title">
        {pending ? 'Waiting for approval' : 'Access not approved'}
      </Typography>

      {pending ? (
        <>
          <p className="portal-access-status__body">
            Your account is set up.
            {' '}
            <strong>{approver}</strong>
            {' '}
            needs to approve your access before referrals they share with you appear here.
          </p>
          <p className="portal-access-status__hint">
            We&apos;ll email you as soon as you&apos;re approved.
          </p>
        </>
      ) : (
        <p className="portal-access-status__body">
          Your request to join the Referral Portal wasn&apos;t approved. If you think this is a mistake,
          contact the practice that invited you.
        </p>
      )}
    </div>
  );
};

PortalAccessStatus.propTypes = {
  status: PropTypes.oneOf(PORTAL_ACCESS_BLOCKED_STATUSES).isRequired,
  approvingOrganizations: PropTypes.arrayOf(PropTypes.string),
};

PortalAccessStatus.defaultProps = {
  approvingOrganizations: [],
};

export default PortalAccessStatus;
